import * as React from "react";
import * as ReactDOM from "react-dom";
import { PanelFooter } from "../react/panel-footer.jsx";
import { PanelHeader } from "../react/panel-header.jsx";
import { Article } from "../react/article";
import { UitkSpacing, EgenciaProvider } from "@egencia/uitk-react";
import { ShareArticle } from "../react/share-article";

EG.HelpCenter.Presenters.PanelSingleArticle = function () {
    //----- Initialize -----//
    const $delegate = $('body');
    const article = EG.bootstrapped.content;
    const articleLink = EG.bootstrapped.articleLink;
    const shareEnabled = EG.analytics.configs['help-center.share_link_enabled'].value && EG.user?.userId > 0;
    const headerTitle = uitk.i18n.msg("panel_header_section_title_help_article");
    uitk.analytics.set('pageName', EG.pageName);
    uitk.analytics.send();
    
    $delegate.on('click', '.contact-us-link', (e) => {
        e.preventDefault();
        omnitureLog.logClickEvent(`${EG.pageName}.ContactUs.Clicked`);
        window.location = `/help-center/panel/contact-options${EG.user ? '' : '/anonymous'}`;
    });
    
    ReactDOM.render((
        <EgenciaProvider>
            <PanelHeader title={headerTitle} hasSearch={false} hasBackBtn={true}/>
            <div className={"panel-content"}>
                <UitkSpacing padding="six">
                    <div>
                        <Article article={article}/>
                        {shareEnabled && (
                            <ShareArticle article={article} articleLink={articleLink}/>
                        )}
                    </div>
                </UitkSpacing>
            </div>
            <PanelFooter />
        </EgenciaProvider>
    ), document.querySelector("#panel-single-article-container"));
    
    convertWistiaTagsToEmbedScripts(true);
};